"use client";

import { useEffect } from "react";

export default function PricingPageError({
  error,
  reset,
}: Readonly<{ error: Error; reset: () => void }>) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error("app error", error, error.message);
    // In Next.js 15, handle 404 errors differently
    // isNotFoundError is not publicly exported
    if (error.message?.includes("NEXT_NOT_FOUND")) {
      // The error will be handled by Next.js's built-in not-found handling
      throw error;
    }
  }, [error]);

  return (
    <div>
      <h2>Something went wrong!</h2>
      <button
        onClick={
          // Attempt to recover by trying to re-render the segment
          () => reset()
        }
      >
        Try again
      </button>
    </div>
  );
}
